import React, {useState} from "react";
import { motion } from "framer-motion";
import {
  BoltIcon,
  RocketLaunchIcon,
  Cog6ToothIcon,
  ChartBarIcon,
  SparklesIcon,
  FireIcon,
} from "@heroicons/react/24/outline";

//25 Nov 2025
import EtModalContactConversation from "@/components/modal/EtModalContactConversation";


const states = [
  {
    id: "running-hard",
    icon: BoltIcon,
    title: "Running Hard · Stuck in Cycles",
    // desc: "Execution is intense but fragmented. You’re driving growth, yet the energy feels scattered. What’s missing is clarity of direction and a unifying magnet for performance.",
    desc: "Execution is intense but fragmented. Your energy feels scattered. What’s missing is clarity of direction and a performance charter.",
  },
  {
    id: "scaling-fast",
    icon: RocketLaunchIcon,
    title: "Scaling Fast · Losing Shape",
    desc: "Growth momentum is strong, but systems lag behind ambition. You need rhythm and structure to scale sustainably without diluting performance or culture.",
  },
  {
    id: "stable-next-orbit",
    icon: ChartBarIcon,
    title: "Stable · Seeking the Next Orbit",
    desc: "You’ve built a solid foundation, but the next horizon demands a re-imagined growth model — one anchored in purpose and powered by precision.",
  },
  {
    id: "high-intent",
    icon: FireIcon,
    title: "High Intent · Low Leverage",
    desc: "Leaders invest effort, but team energy under-converts. Despite commitment, short-term focus and limited self-drive to challenge keep the ROI on leadership time and efforts low.",
  },
  {
    id: "transforming-lacking-cohesion",
    icon: Cog6ToothIcon,
    title: "Transforming · Lacking Cohesion",
    desc: "Multiple initiatives, unclear momentum. The intent is right, but alignment and accountability loops are weak. You need an integrated growth rhythm.",
  },
  {
    id: "leading-change",
    icon: SparklesIcon,
    title: "Leading Change · Ready to Multiply Impact",
    // desc: "You’ve discovered your growth magnet — now it’s time to scale your impact through Trinity’s AI-amplified rhythm of performance.",
    desc: "You’ve found your stride — but scale now depends on consistency, not intensity.The challenge shifts from driving performance to institutionalizing it.",
  },
];

const EtClientsStates = () => {
  // First Created - 17 Oct 2025
  // Author - Atul Pandey
  // Purpose - Enable CxOs to self-identify their current growth state before engaging with Eternity
  // Updated - 25 Nov 2025 - Refined for Unified CTA - ctaSource
    
  // 1 -  Local UI state 
  const [open, setOpen] = useState({ visible: false, source: null }); // 25 Nov 2025 - unified CTA

  return (
    <section
      id="growth-states"
      className="py-24 bg-gradient-to-b from-black via-gray-900 to-black text-white border-t border-white/10"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        {/* Section Heading */}
        <motion.h2
          className="text-3xl md:text-4xl font-bold mb-6 text-orange-600"
          initial={{ opacity: 0, y: -20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          Where Are You in Your Growth Journey?
        </motion.h2>

        {/* Section Intro */}
        <motion.p
          className="text-gray-300 max-w-xl mx-auto mb-16 text-xl"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ delay: 0.2, duration: 0.6 }}
        >
            {/* 25 Oct 2025 - changed intensity with chaos */}
          Every CxO’s journey evolves through phases of <span className="text-orange-600 animate-pulse font-bold">chaos</span>, clarity, and renewal.
          Recognizing where you stand is the first step to realigning energy and performance.
        </motion.p>

        {/* States Grid */}
        <div className="grid gap-10 md:grid-cols-2 lg:grid-cols-3">
          {states.map((s, i) => (
            <motion.div
              key={s.id}
              className="p-8 rounded-xl bg-white/5 hover:bg-white/10 border border-white/10 shadow-lg flex flex-col justify-between transition"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.15, duration: 0.7 }}
            >
              <div>
                <s.icon className="h-10 w-10 text-orange-500 mb-4 mx-auto" />
                <h3 className="text-xl font-semibold mb-3">{s.title}</h3>
                <p className="text-gray-400 text-lg md:text-md mb-6 font-light">{s.desc}</p>
              </div>

                <p className="text-orange-700 text-lg mb-6 font-bold animate-pulse">Is this you?</p>

              
              
              <a
                // href="#contact"
                onClick={() => setOpen({ visible: true, source: "clients-states" })} // 25 Nov 2025
                className="inline-block mt-auto px-5 py-2 rounded-lg bg-orange-600 text-white font-semibold hover:bg-orange-700 transition text-sm cursor-pointer"
              >
                Start a Discovery
              </a>
            </motion.div>
          ))}
        </div>

        {/* Section Bridge */}
        {/* <motion.p
          className="text-gray-400 text-center mt-16 text-xl"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ delay: 0.4, duration: 0.6 }}
        >
          Each stage demands a different kind of rhythm. <span className="text-orange-600">Trinity</span> helps you design yours.
        </motion.p> */}
      </div>
      {/* 25 Nov 2025 */}
      {open.visible && (
        <EtModalContactConversation
          open={open}
          onClose={() => setOpen({ visible: false, source: null })}
        />
      )}
    </section>
  );
};

export default EtClientsStates;